import { useEffect, useState } from "react";

export default function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: document.documentElement.clientWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        function handleResize() {
            // console.log("useWindowSize effect triggered: ", window.innerWidth);
            // console.log(
            //     "useWindowSize effect triggered111111111111: ",
            //     window.screen.width
            // );
            // console.log(
            //     "useWindowSize document.documentElement.clientWidth: ",
            //     document.documentElement.clientWidth
            // );

            setWindowSize({
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
            });
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowSize;
}
